const NEWSLETTER_SV = "https://www2.cloudnine.se/l/127451/2018-12-05/3nqmdn";
const NEWSLETTER_FI = "https://www2.cloudnine.se/l/127451/2020-11-06/47tcbq";
const NEWSLETTER_EN = "https://www2.cloudnine.se/l/127451/2020-11-06/47tchn";
const CONTACT_SV = "https://www2.cloudnine.se/l/127451/2018-10-21/3m8714";
const CONTACT_FI = "https://www2.cloudnine.se/l/127451/2020-11-10/47v3ms";
const CONTACT_EN = "https://www2.cloudnine.se/l/127451/2020-11-10/47v3mv";

export const forms = {
    sv: { newsletter: NEWSLETTER_SV, contact: CONTACT_SV },
    fi: { newsletter: NEWSLETTER_FI, contact: CONTACT_FI },
    en: { newsletter: NEWSLETTER_EN, contact: CONTACT_EN }
}
